import { Tooltip } from "@mui/material";
import { Icon } from "@iconify/react/dist/iconify.js";
import SendIcon from "@mui/icons-material/Send";
import MicIcon from "@mui/icons-material/Mic";
import ClearIcon from "@mui/icons-material/Clear";
import AppLoader from "../../GeneralComponents/AppLoader";
import EditorFormatter from "../EditorFormatter";
import { generateRandomID } from "../../../utils/constant";
import { useClassRoom } from "../../../Hooks/ClassRoom";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import { useTranslation } from "react-i18next";

export const InputActions = (props) => {
  const { t } = useTranslation();
  const {
    selectedObject,
    onCancelUpdate,
    isSubmitting,
    handleSubmit,
    files,
    handleStartRecording,
    isEmpty,
    setFiles,
    setIsSpeaking,
    setShowEmojiPicker,
  } = props;
  const fileUploadID = generateRandomID(20);
  const { isMicAccessible = false } = useClassRoom() ?? {};

  const handleUploadFile = (e) => {
    const _files = Array.from(e.target.files);
    setFiles((old) => [...old, ..._files]);
  };

  const handleOpenEmojiPicker = (e) => {
    setShowEmojiPicker(true);
  };

  return (
    <div className="d-flex align-items-center gap-1 justify-content-end ps-2">
      <EditorFormatter {...props} />
      <Tooltip title={t("chatting.input.emoji")} placement="top">
        <div className="message-send-icon" onClick={handleOpenEmojiPicker}>
          <InsertEmoticonIcon />
        </div>
      </Tooltip>
      <input
        color="primary"
        accept="image/*"
        type="file"
        id={fileUploadID}
        style={{ display: "none" }}
        name=""
        onChange={handleUploadFile}
        multiple
      />
      <label htmlFor={fileUploadID} className="message-send-icon">
        <Tooltip title={t("chatting.input.addImage")} placement="top">
          <Icon icon={"heroicons:photo-solid"} />
        </Tooltip>
      </label>

      {selectedObject?._id && (
        <Tooltip title={t("common.cancel")} placement="top">
          <div className="message-send-icon" onClick={onCancelUpdate}>
            <ClearIcon />
          </div>
        </Tooltip>
      )}

      {!isEmpty || files.length > 0 ? (
        isSubmitting ? (
          <div className="message-send-icon pt-1">
            <AppLoader pixelSize={20} />
          </div>
        ) : (
          <Tooltip title={t("chatting.input.send")}>
            <button className="message-send-icon ps-0" onClick={handleSubmit}>
              <SendIcon />
            </button>
          </Tooltip>
        )
      ) : (
        <>
          <Tooltip title={t("chatting.input.recordMessage")}>
            <div
              className="message-send-icon ps-0"
              onClick={handleStartRecording}
            >
              <MicIcon />
            </div>
          </Tooltip>
          {isMicAccessible && (
            <Tooltip title={t("chatting.input.speakMessage")}>
              <div className="message-send-icon ps-0" onClick={setIsSpeaking}>
                <Icon icon="material-symbols:speech-to-text" />
              </div>
            </Tooltip>
          )}
        </>
      )}
    </div>
  );
};
